import styled from "@emotion/styled";

export const EmblaWrapper = styled.div`
  position: relative;
`;

export const Embla = styled.div<{
  imageFit?: "contain" | "cover";
}>`
  position: relative;
  width: 100%;

  .embla__viewport {
    overflow: hidden;
    width: 100%;
  }

  .embla__viewport.is-draggable {
    cursor: move;
    cursor: grab;
  }

  .embla__viewport.is-dragging {
    cursor: grabbing;
  }

  .embla__container {
    display: flex;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -webkit-tap-highlight-color: transparent;
    margin-left: -10px;
  }

  .embla__slide {
    position: relative;
    min-width: 100%;
    padding-left: 10px;
  }

  .embla__slide__inner {
    display: block;
    position: relative;
    overflow: hidden;
    min-height: 490px;
    max-height: 100%;
  }
`;

export const EmblaDots = styled.div`
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  list-style: none;
`;
